var toObject = require('../internals/to-object');

var hasOwnProperty = {}.hasOwnProperty;

module.exports = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty.call(toObject(it), key);
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/internals/has.js
// module id = 47
// module chunks = 1 2 3 4